"use client";

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import { useAuthStore } from "@/stores/authStore";

export type Unit = {
  id: number;
  name: string;
  short_name: string;
  is_active: number;
};

export function useUnits() {
  const token = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: ["units"],
    queryFn: async () => {
      const { data } = await api.get<{ units: Unit[] }>("/api/units");

      return data.units;
    },
    enabled: Boolean(token),
  });
}
